<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="打卡详情"></el-page-header>
        <Box :title="'签到位置'">
            <template #body>
                <table class="table">
                    <tr>
                        <el-amap
                                vid="amapDemo"
                                :resizeEnable="resizeEnable"
                                :center="center"
                                :zoom="zoom"
                                style="width: 100%; height: 300px;"
                        >
                            <el-amap-marker :position="center"></el-amap-marker>
                        </el-amap>
                    </tr>
                </table>
            </template>
        </Box>

        <Box :title="'现场拍摄图片'">
            <template #body>
                <el-image style="width: 300px;height: 300px;" :src="img_url" fit="cover"
                          :preview-src-list="srcList"></el-image>
                <!--<img style="width: 300px;height: 300px;" :src="img_url"/>-->
            </template>
        </Box>

        <div id="statistics_box" class="message_box">
            <p class="message_title">预约信息</p>
            <table class="table">
                <tbody>
                <tr>
                    <td>预约编号</td>
                    <td>预约健康管理专家</td>
                    <td>预约时间</td>
                    <td>打卡时间</td>
                </tr>
                <tr>
                    <td>{{reservation_id}}</td>
                    <td>{{doctor_name}}</td>
                    <td>{{book_date}} {{half}}</td>
                    <td>{{create_date}}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div style="margin-top: 50px;">
            <el-button @click="submitForm(3)">审核不通过</el-button>
            <el-button type="success" @click="submitForm(2)">审核通过</el-button>
        </div>

    </div>
</template>
<script>
    import env from "@/api/env";
    import Box from "@/components/Box.vue";
    import {check} from "@/utils/checkData";

    export default {
        created() {
            this.id = this.$route.params.id;
        },
        components: {
            Box
        },
        mounted() {
            this.getDetail();
        },
        data() {
            return {
                srcList: [],
                imgUrl: env.IMG_COMMON_URL_PREFIX,
                id: '',
                reservation_id: '',
                longtitude: '',
                latitude: '',
                img_url: '',
                doctor_name: '',
                book_date: '',
                half: '',
                create_date: '',
                resizeEnable: true,
                zoom: 16,
                center: [116.397428, 39.90923],
            };
        },
        methods: {
            // 返回上一页
            goBack() {
                window.history.go(-1);
            },

            getDetail() {
                let params = {
                    'servername': 'Ruyi_AssistantAdminServices',
                    'method': 'clockInfo',
                    'params': {
                        id: this.id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.reservation_id = res.data.data.reservation_id;
                    this.longtitude = res.data.data.longtitude;
                    this.latitude = res.data.data.latitude;
                    if (res.data.data.img_url && res.data.data.img_url != '' && res.data.data.img_url != null) {
                        this.img_url = this.imgUrl + res.data.data.img_url;
                        this.srcList.push(this.imgUrl + res.data.data.img_url);
                    }
                    this.doctor_name = res.data.data.doctor_name;
                    this.book_date = res.data.data.book_date;
                    this.half = res.data.data.half;
                    this.create_date = res.data.data.create_date;
                    this.center = [res.data.data.longtitude, res.data.data.latitude];
                });
            },


            submitForm(status) {
                let flag = "通过审核";
                if(status == "3")
                {
                    flag = "不通过审核";
                }
                this.$confirm(`是否确认 "${flag}"?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                         let params = {
                            'servername': 'Ruyi_AssistantAdminServices',
                            'method': 'clockExamine',
                            'params': {
                                id: this.id,
                                status: status,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                return;
                            }
                            if (res.data.code != '0') {
                                this.$message({
                                    type: "error",
                                    message: '操作失败！'
                                });
                                return false;
                            } else {
                                this.$message({
                                    type: "success",
                                    message: '操作成功',
                                    duration: 1500,
                                    onClose: function () {
                                        window.history.go(-1);
                                    }
                                });
                            }
                        });
                    })
                    .catch(() => {
                    // on cancel
                    });
               
            }

        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 316px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }

    .avatar {
        width: 316px;
        height: 200px;
        display: block;
    }

    .message_box .message_title {
        text-align: left;
        font-size: 16px;
    }

    .message_box table {
        border-collapse: collapse !important;
        color: #606266;
        border-left: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        border-right: 1px solid #ebeef5;
    }

    .message_box table tbody {
        display: table-row-group;
        vertical-align: middle;
        border-color: inherit;
    }

    .message_box table tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
    }

    .message_box table tr:nth-child(1) {
        background-color: #f9fafd;
    }

    .message_box table tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
    }

    .message_box table tr > td:first-of-type {
        border-left: 0;
        border-bottom: 0;
    }

    .message_box table tr td {
        border-left: 1px solid #ebeef5;
        border-top: 1px solid #ebeef5;
        font-size: 14px;
        padding: 15px 0 15px 10px;
        width: auto !important;
        text-align: center;
    }

    .table_message_box {
        margin: 50px 0px 20px 0px;
    }

    .search_data {
        float: right;
        margin: 15px 0px 15px 0px;
        width: 20%;
    }
</style>
 